/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ContentsIndex.
* @enum {}
* @readonly
*/
export default class ContentsIndex {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    
        /**
         * value: 151
         * @const
         */
        "151" = 151;

    
        /**
         * value: 301
         * @const
         */
        "301" = 301;

    
        /**
         * value: 302
         * @const
         */
        "302" = 302;

    
        /**
         * value: 303
         * @const
         */
        "303" = 303;

    
        /**
         * value: 304
         * @const
         */
        "304" = 304;

    
        /**
         * value: 305
         * @const
         */
        "305" = 305;

    
        /**
         * value: 306
         * @const
         */
        "306" = 306;

    
        /**
         * value: 401
         * @const
         */
        "401" = 401;

    
        /**
         * value: 403
         * @const
         */
        "403" = 403;

    
        /**
         * value: 404
         * @const
         */
        "404" = 404;

    
        /**
         * value: 405
         * @const
         */
        "405" = 405;

    
        /**
         * value: 406
         * @const
         */
        "406" = 406;

    
        /**
         * value: 407
         * @const
         */
        "407" = 407;

    
        /**
         * value: 408
         * @const
         */
        "408" = 408;

    
        /**
         * value: 409
         * @const
         */
        "409" = 409;

    
        /**
         * value: 410
         * @const
         */
        "410" = 410;

    
        /**
         * value: 411
         * @const
         */
        "411" = 411;

    
        /**
         * value: 412
         * @const
         */
        "412" = 412;

    
        /**
         * value: 501
         * @const
         */
        "501" = 501;

    
        /**
         * value: 502
         * @const
         */
        "502" = 502;

    
        /**
         * value: 705
         * @const
         */
        "705" = 705;

    
        /**
         * value: 1001
         * @const
         */
        "1001" = 1001;

    
        /**
         * value: 1002
         * @const
         */
        "1002" = 1002;

    
        /**
         * value: 1101
         * @const
         */
        "1101" = 1101;

    
        /**
         * value: 1102
         * @const
         */
        "1102" = 1102;

    
        /**
         * value: 1103
         * @const
         */
        "1103" = 1103;

    
        /**
         * value: 1104
         * @const
         */
        "1104" = 1104;

    
        /**
         * value: 3031
         * @const
         */
        "3031" = 3031;

    
        /**
         * value: 3032
         * @const
         */
        "3032" = 3032;

    
        /**
         * value: 3033
         * @const
         */
        "3033" = 3033;

    
        /**
         * value: 3041
         * @const
         */
        "3041" = 3041;

    
        /**
         * value: 3042
         * @const
         */
        "3042" = 3042;

    
        /**
         * value: 3043
         * @const
         */
        "3043" = 3043;

    
        /**
         * value: 3044
         * @const
         */
        "3044" = 3044;

    
        /**
         * value: 3045
         * @const
         */
        "3045" = 3045;

    
        /**
         * value: 3046
         * @const
         */
        "3046" = 3046;

    
        /**
         * value: 3047
         * @const
         */
        "3047" = 3047;

    
        /**
         * value: 3048
         * @const
         */
        "3048" = 3048;

    
        /**
         * value: 3049
         * @const
         */
        "3049" = 3049;

    
        /**
         * value: 3051
         * @const
         */
        "3051" = 3051;

    
        /**
         * value: 3052
         * @const
         */
        "3052" = 3052;

    
        /**
         * value: 3053
         * @const
         */
        "3053" = 3053;

    
        /**
         * value: 3054
         * @const
         */
        "3054" = 3054;

    
        /**
         * value: 3055
         * @const
         */
        "3055" = 3055;

    
        /**
         * value: 3061
         * @const
         */
        "3061" = 3061;

    
        /**
         * value: 3062
         * @const
         */
        "3062" = 3062;

    
        /**
         * value: 3063
         * @const
         */
        "3063" = 3063;

    
        /**
         * value: 3064
         * @const
         */
        "3064" = 3064;

    
        /**
         * value: 3065
         * @const
         */
        "3065" = 3065;

    
        /**
         * value: 4011
         * @const
         */
        "4011" = 4011;

    
        /**
         * value: 4012
         * @const
         */
        "4012" = 4012;

    
        /**
         * value: 4013
         * @const
         */
        "4013" = 4013;

    
        /**
         * value: 4014
         * @const
         */
        "4014" = 4014;

    
        /**
         * value: 4015
         * @const
         */
        "4015" = 4015;

    
        /**
         * value: 4061
         * @const
         */
        "4061" = 4061;

    
        /**
         * value: 4062
         * @const
         */
        "4062" = 4062;

    
        /**
         * value: 4063
         * @const
         */
        "4063" = 4063;

    
        /**
         * value: 4064
         * @const
         */
        "4064" = 4064;

    
        /**
         * value: 4065
         * @const
         */
        "4065" = 4065;

    
        /**
         * value: 4081
         * @const
         */
        "4081" = 4081;

    
        /**
         * value: 4091
         * @const
         */
        "4091" = 4091;

    
        /**
         * value: 4092
         * @const
         */
        "4092" = 4092;

    
        /**
         * value: 4093
         * @const
         */
        "4093" = 4093;

    
        /**
         * value: 4094
         * @const
         */
        "4094" = 4094;

    
        /**
         * value: 4095
         * @const
         */
        "4095" = 4095;

    
        /**
         * value: 11011
         * @const
         */
        "11011" = 11011;

    
        /**
         * value: 11012
         * @const
         */
        "11012" = 11012;

    
        /**
         * value: 11013
         * @const
         */
        "11013" = 11013;

    
        /**
         * value: 11014
         * @const
         */
        "11014" = 11014;

    
        /**
         * value: 11015
         * @const
         */
        "11015" = 11015;

    
        /**
         * value: 11021
         * @const
         */
        "11021" = 11021;

    
        /**
         * value: 11022
         * @const
         */
        "11022" = 11022;

    
        /**
         * value: 11023
         * @const
         */
        "11023" = 11023;

    
        /**
         * value: 11024
         * @const
         */
        "11024" = 11024;

    
        /**
         * value: 11025
         * @const
         */
        "11025" = 11025;

    
        /**
         * value: 11031
         * @const
         */
        "11031" = 11031;

    
        /**
         * value: 11032
         * @const
         */
        "11032" = 11032;

    
        /**
         * value: 11033
         * @const
         */
        "11033" = 11033;

    
        /**
         * value: 11034
         * @const
         */
        "11034" = 11034;

    
        /**
         * value: 11035
         * @const
         */
        "11035" = 11035;

    
        /**
         * value: 11041
         * @const
         */
        "11041" = 11041;

    
        /**
         * value: 11042
         * @const
         */
        "11042" = 11042;

    
        /**
         * value: 11043
         * @const
         */
        "11043" = 11043;

    
        /**
         * value: 11044
         * @const
         */
        "11044" = 11044;

    
        /**
         * value: 11045
         * @const
         */
        "11045" = 11045;

    

    /**
    * Returns a <code>ContentsIndex</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ContentsIndex} The enum <code>ContentsIndex</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

